import { render, staticRenderFns } from "./educationManagement.vue?vue&type=template&id=42682cb6&scoped=true&"
import script from "./educationManagement.vue?vue&type=script&lang=js&"
export * from "./educationManagement.vue?vue&type=script&lang=js&"
import style0 from "./educationManagement.vue?vue&type=style&index=0&id=42682cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42682cb6",
  null
  
)

component.options.__file = "educationManagement.vue"
export default component.exports